'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Feed = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Date    : 2020/11/25
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Author  : Paco
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Declare : Feed Based React And Redux
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _reactRouterDom = require('react-router-dom');

var _history = require('history');

var _connectedReactRouter = require('connected-react-router');

var _feedRedux = require('@wtdc/feed-redux');

var _feedRedux2 = _interopRequireDefault(_feedRedux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Feed = function () {
  function Feed() {
    var _this = this;

    _classCallCheck(this, Feed);

    this.useRedux = function () {
      var model = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var options = arguments[1];

      if (!_this._reduxContainer) {
        _this._redux = new _feedRedux2.default(model, {
          initReducer: {
            router: (0, _connectedReactRouter.connectRouter)(_this._history)
          },
          middlewares: [(0, _connectedReactRouter.routerMiddleware)(_this._history)]
        });
      }
      return _this;
    };

    this.renderH5 = function () {
      var ReduxContainer = _this._redux.getProvider();
      var history = _this._history;
      var router = _this._router;
      return function Main() {
        return _react2.default.createElement(
          ReduxContainer,
          null,
          _react2.default.createElement(
            _connectedReactRouter.ConnectedRouter,
            { history: history },
            _react2.default.createElement(_reactRouterDom.Route, { path: '/', component: router })
          )
        );
      };
    };

    this._router = null;
    this._history = null;
    this._container = null;
    this._reduxContainer = null;
  }

  /**
   * 设置应用的路由组件
   * @param router
   * @returns {Feed}
   */


  _createClass(Feed, [{
    key: 'useRouter',
    value: function useRouter(router) {
      (0, _invariant2.default)(typeof router === 'function', '[app.router] router should be function, but got ' + (typeof router === 'undefined' ? 'undefined' : _typeof(router)));
      this._router = router;
      return this;
    }

    /**
     * 初始化router
     * @param options
     * @private
     */

  }, {
    key: 'useHistory',
    value: function useHistory(options) {
      this._history = (0, _history.createBrowserHistory)(options);
      return this;
    }

    /**
     * 设置redux
     * @param model 数据参数
     * @param options redux配置
     */

  }, {
    key: 'useActions',


    /**
     * 获取绑定的action
     * @param selectAction
     * @returns {*}
     */
    value: function useActions(selectAction) {
      return this._redux.createBindActions(selectAction);
    }

    /**
     * 获取绑定的selector
     * @param selector
     * @returns {*}
     */

  }, {
    key: 'useSelector',
    value: function useSelector(selector) {
      return this._redux.useSelector(selector);
    }

    /**
     * 检查初始化内容
     */

  }, {
    key: 'checkInit',
    value: function checkInit() {
      (0, _invariant2.default)(this._redux && this._redux, '[app.checkInit]  models not found, You should setRedux first');

      (0, _invariant2.default)(this._router && this._router, '[app.checkInit]  router not found, You should setRouter first');

      (0, _invariant2.default)(this._container && this._container.nodeName, '[app.attatch] container ' + this._container + ' not found');
    }

    /**
     * 初始化项目
     * @param container
     * @returns {Feed}
     */

  }, {
    key: 'attach',
    value: function attach(container) {
      this._container = container;

      // 检查
      this.checkInit();

      // 渲染界面
      _reactDom2.default.render(_react2.default.createElement(this.renderH5()), container);
      return this;
    }

    /**
     * 动态添加redux
     * @param model
     */

  }, {
    key: 'addModel',
    value: function addModel(model) {
      this._redux.addModel(model);
    }

    /**
     * 初始化H5界面
     * @returns {function(): *}
     */

  }]);

  return Feed;
}();

exports.default = new Feed();
exports.Feed = Feed;